import { getAppStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { Formatters, Messages } from '../../codegen/Localize';
import {
  createMultipleItemResultNotificationValues,
  MultipleItemResultNotificationValues
} from '../../commonInfra/contentActions/ActionMessages';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import {
  IErrorItem, MultipleItemResult
} from '../../commonInfra/contentActions/MultipleItemResult';
import { FlowErrors } from '../../flow/services/FlowErrors';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../L10n/L10n';
import { FlowBaseInfo, FlowBasicInfo } from '../models/FlowInfo';
import { Set } from '../models/Set';

export namespace RunFlowOnOutputStepsNotification {
  export function notify(
    result: IResult,
    flow: FlowBasicInfo,
    outputCount: number) {

    let flowSet = Set.singletonForIdItem(flow);
    const notification: MultipleItemResultNotificationValues = createMultipleItemResultNotificationValues(
      new MultipleItemResult(flowSet, result),
      {
        describeSuccessSummary: () => {
          return Messages.runFlowsOnOutputStepsSuccess({ FLOW_NAME: L10n.elideIfLong(flow.name), ITEM_COUNT: outputCount, ITEM_COUNT_LOC: Formatters.formatCount(outputCount) });
        },
        describeErrorSummary: () => {
          return Messages.runFlowsOnOutputStepsError({ FLOW_NAME: L10n.elideIfLong(flow.name) });
        },
        describeErrorDetail: (errorItem: IErrorItem<FlowBaseInfo>) => {
          const siteUrls = siteUrlsSelector(getAppStore().getState());
          const error = {
            flowName: errorItem.item.name,
            errorCode: errorItem.error.code,
          };
          return {
            itemName: errorItem.item ? errorItem.item.name : L10n.elideIfLong(flow.name),
            itemUrl: siteUrls.flowUrl(errorItem.item ? errorItem.item.id : flow.id),
            errorMessage: FlowErrors.errorMessageFor(error),
          };
        }
      }
    );
    ContentActionNotification.displayItemizedToastsForResult(notification);
  }
}

export type RunFlowOnOutputStepsNotification = typeof RunFlowOnOutputStepsNotification;
